import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetAllSC_ST_AI_Subject = createAsyncThunk(
  "SC_ST_AI_Subject/GetAllSC_ST_AI_Subject",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient("application/json");

      const apiClient = await getApiClient();
      const response = await apiClient.post(
        `api/SC_ST_AI_Subject/GetAllSC_ST_AI_Subject`,

        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const SC_ST_AI_Subject = createSlice({
  name: "SC_ST_AI_Subject",
  initialState: {
    //------------- GetSC_ST_AI_Subject ---------------------
    SC_ST_AI_SubjectList: [],
    loadingSC_ST_AI_SubjectList: false,
    errorSC_ST_AI_SubjectList: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllSC_ST_AI_Subject.pending, (state, action) => {
        state.loadingSC_ST_AI_SubjectList = true;
        state.SC_ST_AI_SubjectList = action.payload;
        state.errorSC_ST_AI_SubjectList = null;
      })
      .addCase(GetAllSC_ST_AI_Subject.fulfilled, (state, action) => {
        state.loadingSC_ST_AI_SubjectList = false;
        state.SC_ST_AI_SubjectList = action.payload;
      })
      .addCase(GetAllSC_ST_AI_Subject.rejected, (state, action) => {
        state.loadingSC_ST_AI_SubjectList = false;
        state.SC_ST_AI_SubjectList = action.payload;
      });
  },
});

export default SC_ST_AI_Subject.reducer;
